import React from "react";
import { Link } from "react-router-dom";
import { Phone, ArrowRight } from "lucide-react";
import { useCompany } from "@/context/CompanyContext";
import { trackEvent } from "@/lib/ga";

export default function CtaBlock({ heading = "Ready for Comfort That's Ready for Liftoff?", sub = "Get fast, honest HVAC service from your local Space Coast experts. Call now or request your free estimate." }) {
  const { company } = useCompany();
  return (
    <section className="relative overflow-hidden bg-navy text-white" data-testid="cta-block">
      <div className="absolute inset-0 dot-grid opacity-60" aria-hidden="true" />
      <div className="relative max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 md:py-20 text-center">
        <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight">{heading}</h2>
        <p className="mt-4 text-lg text-slate-200 max-w-2xl mx-auto leading-relaxed">{sub}</p>
        <div className="mt-8 flex flex-col sm:flex-row gap-4 justify-center">
          <a
            href={`tel:${company.phone_href || ""}`}
            onClick={() => trackEvent("phone_click", { location: "cta_block" })}
            data-testid="cta-call-button"
            className="inline-flex items-center justify-center gap-2 bg-launch hover:bg-launch-dark text-white font-bold py-3.5 px-8 rounded-md shadow-lg transition-colors duration-200"
          >
            <Phone className="h-5 w-5" /> Call {company.phone || ""}
          </a>
          <Link
            to="/contact-us"
            onClick={() => trackEvent("estimate_click", { location: "cta_block" })}
            data-testid="cta-estimate-button"
            className="inline-flex items-center justify-center gap-2 bg-white/10 hover:bg-white/20 border border-white/30 text-white font-semibold py-3.5 px-8 rounded-md transition-colors duration-200"
          >
            Get a Free Estimate <ArrowRight className="h-5 w-5" />
          </Link>
        </div>
      </div>
    </section>
  );
}
